export default "__VITE_ASSET__ffb635fc__"